import { _ } from "libs";

import React from "react";
import { Form, Field } from "react-final-form";
import { Profile } from "../../types";
import GenderSelect from "../forms/controls/genderSelect";
import DoBSelect, { parseDob, formatDob } from "../forms/controls/dobSelect";
import CitySelect from "../forms/controls/citySelect";

type Props = {
	onChange: Function;
	profile: Profile;
};

export function ProfileForm({ onChange, profile }: Props) {
	return (
		<Form
			onSubmit={({ aboutMe, city, dob, gender, useNetwork }: any, mutators) => {
				let cityValue = "";
				if (city && city.hasOwnProperty("value")) {
					cityValue = city.value;
				}
				onChange({ aboutMe, city: cityValue, dob, useNetwork, gender });
			}}
			initialValues={{ ...profile, useNetwork: true }}
			render={({ handleSubmit, submitting, pristine, invalid, values }) => (
				<form onSubmit={handleSubmit} className="lite">
					<Field name="aboutMe">
						{({ input, meta }) => (
							<div className="field medium oneLine">
								<label>{_("form.aboutMe.label")}</label>
								<textarea
									{...input}
									className="oneLine"
									placeholder={_("onboarding.profileForm.about.placeholder")}
								/>
								{meta.touched && meta.error && <p className="error">{meta.error}</p>}
							</div>
						)}
					</Field>
					<Field name="gender">
						{({ input, meta, ...rest }) => (
							<div className="field medium">
								<label>{_("onboarding.profileForm.gender.label")}</label>
								<GenderSelect
									{...{ input, meta, ...rest }}
									prompt={_("onboarding.profileForm.gender.prompt")}
								/>
								{meta.touched && meta.error && <p className="error">{meta.error}</p>}
							</div>
						)}
					</Field>
					<Field name="dob" parse={parseDob} format={formatDob}>
						{({ input, meta, ...rest }) => (
							<div className="field medium">
								<label>{_("onboarding.profileForm.dob.label")}</label>
								<DoBSelect
									{...{ input, meta, ...rest }}
									dayPrompt={_("onboarding.profileForm.dob.dayPrompt")}
									monthPrompt={_("onboarding.profileForm.dob.monthPrompt")}
									yearPrompt={_("onboarding.profileForm.dob.yearPrompt")}
								/>
								{meta.touched && meta.error && <p className="error">{meta.error}</p>}
								<p className="note small">{_("onboarding.profileForm.dob.description")}</p>
							</div>
						)}
					</Field>
					<Field name="city">
						{({ input, meta, ...rest }) => (
							<div className="field searchField medium">
								<label>{_("form.city.label")}</label>
								<CitySelect
									{...{ input, meta, ...rest }}
									placeholder={_("onboarding.profileForm.city.placeholder")}
									getDisplayValue={value => {
										if (typeof value === "object") {
											return value.value;
										}
										return value;
									}}
								/>
								{meta.touched && meta.error && <p className="error">{meta.error}</p>}
							</div>
						)}
					</Field>
					<Field name="useNetwork" type="checkbox">
						{({ input, meta }) => (
							<>
								<div className="field checkbox">
									<label>
										<input {...input} type="checkbox" />
										{_("onboarding.profileForm.playerNetwork.label")}
									</label>
								</div>
								<div className="note">{_("onboarding.profileForm.playerNetwork.description")}</div>
							</>
						)}
					</Field>
					<div className="buttons">
						<button type="submit" className="button" disabled={submitting || invalid}>
							{_("continueBtn")}
						</button>
					</div>
				</form>
			)}
		/>
	);
}

export default ProfileForm;
